import * as React from "react"

const LineColor2 = React.forwardRef((props, pathRef) => {
        return (
            <svg
                width={2}
                height={354}
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                viewBox={`0 0 2 354`}


            >
                <path
                    id={"line-color-2"}
                    ref={pathRef}
                    d="M1 0v354"
                    strokeWidth={2}

                    stroke="#DEDDE2"
                    strokeDashoffset={props.normalizedPosition}
                    strokeDasharray={props.pathLength}
                />
            </svg>
        )
    }
)

export default LineColor2
